import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const promotionPageStyles = {
    wrap: css`
        min-height: 50vh;
    `,
    background: css`
        width: 100%;
        height: 200px;
    `,
    header: css`
        display: flex;
        align-items: center;
        gap: 16px;
        padding-top: 10px;
        padding-bottom: 10px;
    `,
    title: css`
        display: flex;
        align-items: center;
        gap: 10px;
        img {
            width: 36px;
        }
        h6 {
            font-size: 18px;
        }
    `,
    tabList: css`
        flex: 1;
        display: flex;
        list-style-type: none;
        background-image: linear-gradient(88deg, ${colors.primary}, #2c5490, ${colors.primary});
    `,
    tabItem: css`
        line-height: 45px;
        text-align: center;
        color: ${colors.white};
        text-transform: uppercase;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        padding-left: 12px;
        padding-right: 12px;
        font-size: 14px;

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            height: 3px;
            width: 0;
            background-color: #ddca8c;
            transition: width 0.3s ease;
        }

        &:hover {
            background-color: #053c3e;
        }

        &:hover::after {
            width: 100%;
        }

        &.active {
            background-color: #053c3e;
        }

        &.active::after {
            width: 100%;
        }

        span {
            position: relative;
            z-index: 1;
            font-weight: 500;
        }
    `,

    promoContent: css`
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 16px;
        background-image: linear-gradient(37deg, ${colors.primary}, #2c5490, ${colors.primary});
    `,
    promoItem: css`
        flex: 0 0 calc(100% / 3);
        max-width: calc(100% / 3);
        padding: 5px;
    `,
    promoItemInner: css`
        background: #025656;
        display: flex;
        height: 100%;
        position: relative;
        .wrap-img {
            display: flex;
            img {
                width: 100%;
                transition: 0.25s;
            }
        }
        .btn-detail {
            position: absolute;
            bottom: 6px;
            right: 6px;
            background-image: linear-gradient(28deg, #ddca8c, #fcf3d4, #ddca8c, #fcf3d4, #ddcb8c) !important;
            font-weight: 600;
            padding: 8px 12px;
            border-radius: 8px;
            span {
                text-transform: uppercase;
                font-size: 14px;
                font-weight: 300;
                background: -webkit-linear-gradient(28deg, #5b1313, #931f1f);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        p {
            flex: 1;
            padding: 8px;
        }
    `,
    noPromo: css`
        padding: 60px 0;
        text-align: center;
    `,
};
export default promotionPageStyles;
